export const hexToRgbWithAlpha = (hex, alpha) => {
  const [r1, g1, b1] = hex.match(/\w\w/g).map(x => parseInt(x, 16));

  const r = Math.round((1 - alpha) * 255 + alpha * r1);
  const g = Math.round((1 - alpha) * 255 + alpha * g1);
  const b = Math.round((1 - alpha) * 255 + alpha * b1);

  return `rgb(${r},${g},${b})`;
};
